/* CapariHaus · ürün kartı fotoğrafları kendiliğinden kayar (22 Eki 2026)
   Ana sayfa ve Tüm Ürünler kartlarındaki [data-chs-otokay] şeritleri. Parmakla kaydırma aynen çalışır.
   - Kart ekranda değilken, sekme arka plandayken, fare kartın üstündeyken durur.
   - Müşteri dokunur ya da kaydırırsa o kart 8 sn bekler, sonra devam eder.
   - Bütün kartlar aynı saatle, aynı anda kayar (22 Eki, kullanıcı: "senkron içerisinde olsun").
   - "Hareketi azalt" açık olan cihazda hiç kaymaz. */
(function(){
  if(window.__chsOtokay) return; window.__chsOtokay=true;
  var ARA=3500, BEKLE=8000;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function kur(){
    var seritler=document.querySelectorAll('[data-chs-otokay]');
    if(!seritler.length||!('IntersectionObserver' in window)) return;
    var hepsi=[];
    seritler.forEach(function(k){
      var g=k.querySelectorAll('img'); if(g.length<2||k.__chs) return; k.__chs=true;
      var d={k:k, g:g, gorunur:false, uzerinde:false, sonDokunma:0};
      hepsi.push(d);
      var dur=function(){ d.sonDokunma=Date.now(); };
      k.addEventListener('pointerdown',dur,{passive:true});
      k.addEventListener('touchstart',dur,{passive:true});
      k.addEventListener('wheel',dur,{passive:true});
      if(window.matchMedia('(hover:hover)').matches){
        k.addEventListener('mouseenter',function(){ d.uzerinde=true; });
        k.addEventListener('mouseleave',function(){ d.uzerinde=false; });
      }
      g[1].loading='eager';   /* sıradaki fotoğraf kaymadan önce hazır olsun */
    });
    if(!hepsi.length) return;
    var go=new IntersectionObserver(function(kay){
      kay.forEach(function(x){ var d=x.target.__chsD; if(!d) return;
        d.gorunur=x.intersectionRatio>=.6; });
    },{threshold:[0,.6]});
    hepsi.forEach(function(d){ d.k.__chsD=d; go.observe(d.k); });

    /* tek saat: her vuruşta bütün kartlar aynı sıradaki fotoğrafa geçer (adim % fotoğraf sayısı);
       sonradan ekrana giren ya da dokunulduktan sonra devam eden kart da aynı sıraya oturur */
    var adim=0;
    setInterval(function(){
      if(document.hidden) return;
      adim++;
      var t=Date.now();
      hepsi.forEach(function(d){
        if(!d.gorunur||d.uzerinde||t-d.sonDokunma<BEKLE) return;
        var w=d.k.clientWidth; if(!w) return;
        var n=d.g.length, y=adim%n;
        if(d.g[(y+1)%n]) d.g[(y+1)%n].loading='eager';
        if(Math.round(d.k.scrollLeft/w)!==y) d.k.scrollTo({left:y*w,behavior:'smooth'});
      });
    },ARA);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',kur); else kur();
})();
